import { defaultDirection } from "../constants/defaultValues";

export const mapOrder = (array, order, key) => {
  array.sort(function(a, b) {
    const A = a[key];
    const B = b[key];
    if (order.indexOf(`${A}`) > order.indexOf(`${B}`)) {
      return 1;
    }
    return -1;
  });
  return array;
};

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; // January is 0!

  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}.${mm}.${yyyy}`;
};

export const getCurrentTime = () => {
  const now = new Date();
  return `${now.getHours()}:${now.getMinutes()}`;
};

export const getDirection = () => {
  let direction = defaultDirection;
  if (localStorage.getItem("direction")) {
    const localValue = localStorage.getItem("direction");
    if (localValue === "rtl" || localValue === "ltr") {
      direction = localValue;
    }
  }
  return {
    direction,
    isRtl: direction === "rtl"
  };
};

export const setDirection = localValue => {
  let direction = "ltr";
  if (localValue === "rtl" || localValue === "ltr") {
    direction = localValue;
  }
  localStorage.setItem("direction", direction);
};

export const arrayToObject = (array, keyField) =>
  array.reduce((obj, item) => {
    const toReturn = obj;
    toReturn[item[keyField]] = item;
    return toReturn;
  }, {});

export const importAll = r => {
  return r.keys().map(r);
};

export const upperFirst = s => {
  try {
    return s.charAt(0).toUpperCase() + s.slice(1);
  } catch (err) {}
  return s;
};

export const titleCase = (str, locale = "en") => {
  const splitStr = str.toLocaleLowerCase(locale).split(" ");

  for (let i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }

  return `${splitStr.join(" ")}`;
};

export const titleCaseForDash = (str, locale = "en") => {
  const splitStr = str.toLocaleLowerCase(locale).split(" ");

  for (let i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }

  return `${splitStr.join("-")}`;
};

export const titleCaseForSlash = (str, locale = "en") => {
  const splitStr = str.toLocaleLowerCase(locale).split(" ");

  for (let i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }

  return `${splitStr.join("/")}`;
};
